import { ShamDashboardData } from 'sham-components/features/dashboard';
import {
  ShamDashboardSquare01StrokeIcon,
  ShamDeliveryTruck01GreyIcon,
  ShamPackage03Icon,
  ShamPackageIcon,
  ShamSettingsIcon,
  ShamUserGroup03NewIcon,
  ShamUserstargreyIcon,
} from 'sham-components/icons';

export async function dashboardLayoutDataFactory(
  dashData: ShamDashboardData,
  translate: any,
) {
  dashData.navLinks.set([
    {
      name: 'Dashboard',
      paths: 'dashboard',
      icon: ShamDashboardSquare01StrokeIcon,
    },
    {
      name: translate.instant('menu.orders'), // استخدام المفتاح بدلاً من النص
      paths: 'orders',
      icon: ShamPackageIcon,
    },
    {
      name: 'Routes',
      paths: 'routes',
      icon: ShamDeliveryTruck01GreyIcon,
    },
    {
      name: translate.instant('menu.drivers'), // استخدام المفتاح بدلاً من النص
      paths: 'drivers',
      icon: ShamUserGroup03NewIcon,
    },
    {
      name: translate.instant('menu.reviews'), // استخدام المفتاح بدلاً من النص
      paths: 'reviews',
      icon: ShamUserstargreyIcon,
    },
    {
      name: 'Vehicle Rates',
      paths: 'delivery-settings',
      icon: ShamPackage03Icon,
    },
    {
      name: 'Setting',
      paths: 'settings',
      icon: ShamSettingsIcon,
    },
  ]);
}
